import { CircularProgress } from '@mui/material'
import React from 'react'

const Loader = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
      }}
    >
      <CircularProgress style={{ color: '#A4A4FF' }} />
    </div>
  )
}

export default Loader
